import React from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'
import { getDecodedRemarks } from '../util/remarksDecoder'

const MetarDetailRemarks = props => {
  if(!props.remarks) {
    return null
  }
  return (
    <MetarDetailSection
      className={props.className}
      title={"REMARKS"}
    >
      {getDecodedRemarks(props.remarks).map((rem, idx) => {
        return (
          <MetarDetailSectionItem
            key={idx}
            value={rem}
          />
        )
      })}
      <MetarDetailSectionItem 
        key={props.remarks}
        value={props.remarks}
      />
    </MetarDetailSection>
  )
}

export default MetarDetailRemarks



// WEBPACK FOOTER //
// ./src/components/MetarDetailRemarks.js